module.exports = __webpack_public_path__ + "assets/img/21698910070_ 1.f754c067.png";